module.exports = __webpack_public_path__ + "img/woche.86ff0807.svg";